import {Box, Typography} from '@mui/material';
import React from 'react';

const styles = {
    label: {
        color: '#02B033',
        fontSize: '0.75rem',
    },
    box: {
        display: 'flex',
        backgroundColor: '#e5f7ea',
        borderRadius: '0.25rem',
        padding: '0rem 0.5rem',
        height: '1.375rem',
        // width: '3.9375rem',
        alignItems: 'center',
    },
};

function AcceptedLabel() {
    return (
        <Box sx={styles.box}>
            <Typography sx={styles.label}>Accepted</Typography>
        </Box>
    );
}

export default AcceptedLabel;
